import './App.css';
import lost from "./images/lost.gif";
import {useSearchParams} from "react-router";
import giveItToMeBaby from "./images/give_it_to_me_baby.gif";
import crossStreetSign from "./images/14th_Bertona_sign.jpg";
import stairs from "./images/stairs.jpg";
import parkingStep1 from "./images/Parking_Step_1.jpg";
import parkingStep2 from "./images/Parking_Step_2.jpg";
import parkingStep3 from "./images/Parking_Step_3.jpg";
import parkingStep4 from "./images/Parking_Step_4.jpg";
import parkingStep5 from "./images/Parking_Step_5.jpg";
import parkingStep6 from "./images/Parking_Step_6.jpg";
import parkingStep7 from "./images/Parking_Step_7.jpg";
import parkingStep8 from "./images/Parking_Step_8.jpg";


function MainContent() {

    const [searchParams] = useSearchParams();
    const coolAfChick = searchParams.get("coolAfChick");
    const iKnowYou = searchParams.get("iKnowYou");

    if(iKnowYou === "directions"){
        return (
            <>
                <div className="header">
                    <div className="title">Justmartythings</div>
                </div>
                <div className="siteContent">
                    <div className="contentContainer">
                        <h1>Parking Instructions</h1>
                        <img src={crossStreetSign} className={"container"} alt="crossStreetSign" />
                        <h2>W Bertona St 14th 98119</h2>
                        <h3>pretty much get as close to that cross street as you can. If you can't find parking your best bet is to go up the hill, but prepare them legs for the walk back.</h3>
                        <h3>See below for getting from that cross street to my house</h3>
                        <div className="imageContainer">
                            <img src={stairs} className={"container"} alt="stairs" />
                            <img src={parkingStep1} className={"container"} alt="parkingStep1" />
                            <img src={parkingStep2} className={"container"} alt="parkingStep2" />
                            <img src={parkingStep3} className={"container"} alt="parkingStep3" />
                            <img src={parkingStep4} className={"container"} alt="parkingStep4" />
                            <img src={parkingStep5} className={"container"} alt="parkingStep5" />
                            <img src={parkingStep6} className={"container"} alt="parkingStep6" />
                            <img src={parkingStep7} className={"container"} alt="parkingStep7" />
                            <img src={parkingStep8} className={"container"} alt="parkingStep8" />
                        </div>
                    </div>
                </div>
            </>
        );
    }
    else if (coolAfChick){
        return(
            <>
                <div className="header">
                    <div className="title">Justmartythings</div>
                </div>
                <div className="siteContent">
                    <div className="description">
                        <h4>{coolAfChick} you gorgeous</h4>
                        <h4>let's hangout sometime</h4>
                        <h4>425 445 2656</h4>
                        <div className="imageContainer">
                            <img src={giveItToMeBaby} className={"container"} alt="lost" />
                        </div>
                    </div>
                </div>
            </>
        )
    }
    else{
        return (
            <>
                <div className="header">
                    <div className="title">Justmartythings</div>
                </div>
                <div className="siteContent">
                    <div className="contentContainer">
                        <div className="imageContainer">
                            <img src={lost} className={"container"} alt="lost" />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default MainContent;
